import { NewSubscriptionFlowContext } from "@/store/machine"

// context.pricing_version is only set at quote creation (ADD_OWNER_FIRST_INFORMATIONS);
// quote retrieval only fills quote.meta.pricing_version, so both must be checked.
export function getPricingVersion(
  context: Pick<NewSubscriptionFlowContext, "pricing_version" | "quote">
): string | undefined {
  return context.pricing_version || context.quote?.meta?.pricing_version
}
